import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import { Link } from "react-router-dom";
import { getPlatformRouteDeclarations } from "../services/api";

export default function PlatformRouteDeclarations() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [statusFilter, setStatusFilter] = useState("pending_approval");

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getPlatformRouteDeclarations({ status: statusFilter });
        const list = Array.isArray(data) ? data : data.items ?? [];
        if (!alive) return;
        setItems(list);
      } catch (e) {
        if (!alive) return;
        setError(e?.message || "Eroare la încărcare");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [statusFilter]);

  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-slate-900">Declarații de traseu în așteptare</h1>
        <div className="flex items-center gap-2">
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900">
            <option value="pending_approval">În așteptare</option>
            <option value="approved">Aprobate</option>
            <option value="signed">Semnate</option>
          </select>
        </div>
      </div>

      <Card>
        {loading ? (
          <div className="text-sm text-slate-500">Se încarcă…</div>
        ) : error ? (
          <div className="text-sm text-red-600">{error}</div>
        ) : items.length === 0 ? (
          <div className="text-sm text-slate-500">Nu există declarații de traseu în așteptare.</div>
        ) : (
          <ul className="divide-y divide-slate-100">
            {items.map((it) => (
              <li key={it.id} className="py-4 flex items-center gap-4">
                <div className="flex-1">
                  <div className="font-semibold text-slate-900">{it.full_name || it.employee_name || "-"}</div>
                  <div className="text-sm text-slate-500">{it.employer_name_snapshot || it.employer_name || ""} • {it.worksite_name_snapshot || it.worksite_name || ""} • {it.worksite_city_snapshot || it.worksite_city || ""}</div>
                  <div className="text-xs text-slate-400 mt-1">{it.submitted_for_approval_at || it.created_at || ""} • {it.status}</div>
                </div>
                <div className="flex-shrink-0 flex gap-2">
                  <Link to={`/platform/route-declarations/${it.id}`}>
                    <Button variant="secondary">Vezi detalii</Button>
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
